import { render, staticRenderFns } from "./PricesOutput.vue?vue&type=template&id=7b78a5a8&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/contract/PricesOutput.vue
// module id = null
// module chunks = 